export default {"src":"/_next/static/media/ico_warning-small.e7911d26.svg","height":28,"width":32};